import PropTypes from "prop-types";
import styles from "./index.css";

const CategoryHeaderCopy = ({ content }) => (
  <div className={styles.copy}>
    <p className={styles.description}>{content}</p>
  </div>
);

CategoryHeaderCopy.propTypes = {
  content: PropTypes.string.isRequired
};

export default CategoryHeaderCopy;
